import * as React from "react";

import { Kit, KitOverview } from "./components";

export default class Discount extends React.Component<{}> {
    public render() {
        const kit: Kit ={
            id: "elements",
            name: "Sketch Elements",
            overview: "The most comprehensive React Native starter kit",
            // tslint:disable-next-line:max-line-length
            description: "One high quality codebase, 35 beautiful screens, and 50 reusable React components",
            price: {
                value: 1950,
                originalPrice: 7500,
                currency: "USD"
            },
            documentation: "https://wcandillon.github.io/react-native-elements",
            color: "#73C700",
            expo: "exp://exp.host/@wcandillon/react-native-elements",
            thumbnail: require("./components/kits/elements.jpg"),
            thumbnailPreview: require("./components/kits/elements-preview.jpg"),
            testFlight: "https://testflight.apple.com/join/u9Ligqwa",
            apk: "https://firebasestorage.googleapis.com/v0/b/react-native-ui-kits.appspot.com/o/builds%2Fandroid%2Freact-native-elements-db9cd52f681e479b8c8739ebe7b6e0df-signed.apk?alt=media&token=b4681b30-b821-45d8-893e-6368bfd66123",
        };
        return (
              <KitOverview reverse={false} specialPromo={true} {...{kit}} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Discount.tsx